import { render, staticRenderFns } from "./UpcomingVaccinesModal.vue?vue&type=template&id=23cea697&scoped=true"
import script from "./UpcomingVaccinesModal.vue?vue&type=script&lang=js"
export * from "./UpcomingVaccinesModal.vue?vue&type=script&lang=js"
import style0 from "./UpcomingVaccinesModal.vue?vue&type=style&index=0&id=23cea697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cea697",
  null
  
)

export default component.exports